import React, { type PropsWithChildren, type JSX } from "react";

interface UiDetailsHeaderProps extends PropsWithChildren {
  banner?: string;
  links?: JSX.Element;
}

export default function UiDetailsHeader({ banner, links, children }: UiDetailsHeaderProps) {
  return (
    <header>
      <div
        className="flex h-20 shrink-0 items-center justify-center border-b-0.5 border-neutral-500 bg-gradient-to-b from-neutral from-10% to-primary-25 to-90% bg-cover bg-left bg-no-repeat px-6 md:justify-end"
        style={banner ? { backgroundImage: `url(${banner})` } : undefined}
      >
        {links}
      </div>
      <div className="relative flex justify-center px-6">{children}</div>
    </header>
  );
}
